import ErrorMessage from "legacy/ErrorMessage"
import StripeElement from "legacy/credit-cards/StripeElement"
import { paymentMethodDisplayText } from "legacy/helpers.es6"
import { validatorFactory } from "legacy/validatorFactory"
import _ from "lodash"
import PropTypes from "prop-types"
import React from "react"

import Modal from "src/components/Modal"

class SelectCreditCardSection extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      processing: false,
      showModal: false,
      // Internal state for modal selection - separate from props
      modalSelectedCardId: props.selectedCardId || "add_new_card",
      cardErrors: null,
    }
    this.validator = validatorFactory()
    this.stripeElementRef = React.createRef()
    this.stripeResponse = this.stripeResponse.bind(this)
    this.cardError = this.cardError.bind(this)
    this.closeModal = this.closeModal.bind(this)
    this.openModal = this.openModal.bind(this)
    this.submit = this.submit.bind(this)
    this.setSelectedCard = this.setSelectedCard.bind(this)
    this.cardSelector = this.cardSelector.bind(this)
    this.modalContents = this.modalContents.bind(this)
    this.buttonText = this.buttonText.bind(this)
    this.postSubmit = this.postSubmit.bind(this)
  }

  openModal() {
    // Reset modal selection to current prop value when opening
    this.setState({
      showModal: true,
      modalSelectedCardId: this.props.selectedCardId || "add_new_card",
    })
  }

  closeModal() {
    this.setState({
      showModal: false,
      processing: false,
      cardErrors: null,
    })
  }

  postSubmit(cardToken = null) {
    $.post(`${this.props.endpoint}`, { stripeToken: cardToken }, (data) => {
      this.props.setStripeCard(data)
      this.closeModal()
    }).fail((data) => {
      const message = data.responseJSON.error.replace("Your", "The")
      this.cardError(message)
    })
  }

  stripeResponse(response) {
    this.postSubmit(response.id)
  }

  submit() {
    if (this.validator.allValid()) {
      this.setState({
        processing: true,
        cardErrors: null,
      })
      if (this.state.modalSelectedCardId === "add_new_card") {
        this.stripeElementRef.current.createStripePaymentMethod()
      } else {
        this.props.setStripeCard(
          _.find(this.props.userCards, {
            stripePaymentMethodId: this.state.modalSelectedCardId,
          })
        )
        this.closeModal()
      }
    } else {
      this.validator.showMessages()
      this.forceUpdate()
    }
  }

  setSelectedCard(event) {
    this.setState({ modalSelectedCardId: event.target.value })
  }

  cardSelector() {
    if (this.props.userCards) {
      return (
        <div className="form-group">
          <label>Select Payment Method</label>
          <select
            className="form-control"
            value={this.state.modalSelectedCardId}
            onChange={this.setSelectedCard}
          >
            <option value="add_new_card">Add New Card</option>
            {this.props.userCards.map((paymentMethod) => {
              return (
                <option
                  key={paymentMethod.id}
                  value={paymentMethod.stripePaymentMethodId}
                >
                  {paymentMethodDisplayText(paymentMethod)}
                </option>
              )
            })}
          </select>
        </div>
      )
    }
    return null
  }

  cardError(message = null) {
    this.setState({
      processing: false,
      cardErrors: message,
    })
  }

  modalContents() {
    return (
      <div>
        {this.cardSelector()}
        {(this.state.modalSelectedCardId === "add_new_card" ||
          !this.props.userCards) && (
          <StripeElement
            ref={this.stripeElementRef}
            successCallback={this.stripeResponse}
            errorCallback={this.cardError}
          />
        )}
      </div>
    )
  }

  buttonText() {
    const card = _.find(this.props.userCards, {
      stripePaymentMethodId: this.props.selectedCardId,
    })
    if (this.props.selectedCardId === "add_new_card" || !card) {
      return "Add Card"
    } else {
      return (
        <span>
          <span className="font-medium text-black">{card.title}</span> |{" "}
          <span className="text-muted">
            <i className="fa-kit fa-edit" /> Change
          </span>
        </span>
      )
    }
  }

  render() {
    this.validator.purgeFields()
    return (
      <div>
        <div className="form-group">
          <label>Payment Method</label>
          <button
            type="button"
            className="btn btn-secondary w-full"
            onClick={this.openModal}
          >
            {this.buttonText()}
          </button>
        </div>
        <Modal
          isOpen={this.state.showModal}
          onClose={this.closeModal}
          size="mediumFixed"
        >
          <Modal.Header title="Change Payment Method" />
          <Modal.Body>
            {this.modalContents()}
            <ErrorMessage>{this.state.cardErrors}</ErrorMessage>
          </Modal.Body>
          <Modal.Footer
            cancelBtnText="Cancel"
            confirmBtnText="Update"
            onClose={this.closeModal}
            onSubmit={this.submit}
            confirmBtnLoading={this.state.processing}
          />
        </Modal>
      </div>
    )
  }
}

SelectCreditCardSection.propTypes = {
  endpoint: PropTypes.string.isRequired,
  selectedCardId: PropTypes.string,
  setStripeCard: PropTypes.func.isRequired,
  userCards: PropTypes.array,
}

export default SelectCreditCardSection
